import en from "./en";
import {
    addMessages,
    init,
    getLocaleFromHash,
    getLocaleFromQueryString,
    getLocaleFromNavigator,
    _,
} from "svelte-i18n";
import { get } from "svelte/store";

export function initTranslations() {
    addMessages("en", en);
    init({
        fallbackLocale: "en",
        initialLocale:
            getLocaleFromNavigator() ||
            getLocaleFromHash() ||
            getLocaleFromQueryString(),
    });
}

// id?: string;
// locale?: string;
// format?: string;
// default?: string;
// values?: Record<string, string | number | Date>;
export function getTranslation(id, options) {
    return get(_)(id, options);
}
